/**
 * Knopf zum Speichern der Videos eines Rezepts im Gerät. Bilder speichert der
 * Service Worker von selbst; Videos sind groß und werden nur auf Wunsch
 * vollständig geladen.
 */
import { useEffect, useState } from 'react';
import { allCached, cacheFiles, offlineStorageAvailable } from '../lib/offline.ts';
import { texts } from '../texts/de.ts';

/** Videos eines Rezepts für offline speichern. */
export function OfflineVideosButton({ urls }: { readonly urls: readonly string[] }) {
  const [state, setState] = useState<'unknown' | 'missing' | 'saving' | 'saved' | 'failed'>('unknown');
  const key = urls.join('|');

  useEffect(() => {
    let alive = true;
    void allCached(key === '' ? [] : key.split('|')).then((cached) => {
      if (alive) {
        setState(cached ? 'saved' : 'missing');
      }
    });
    return () => {
      alive = false;
    };
  }, [key]);

  if (!offlineStorageAvailable() || urls.length === 0 || state === 'unknown') {
    return null;
  }
  if (state === 'saved') {
    return <p className="text-xs text-content-muted">✓ {texts.sync.savedForOffline}</p>;
  }
  return (
    <button
      type="button"
      disabled={state === 'saving'}
      onClick={() => {
        setState('saving');
        cacheFiles(urls)
          .then(() => setState('saved'))
          .catch(() => setState('failed'));
      }}
      className="rounded-lg border border-border-subtle px-3 py-1.5 text-xs disabled:opacity-60"
    >
      {state === 'saving'
        ? texts.sync.savingOffline
        : state === 'failed'
          ? `${texts.sync.saveOffline} (${texts.common.retry})`
          : texts.sync.saveOffline}
    </button>
  );
}
